import { AttachedCommunication } from "@/Common/Models/AttachedCommunication/AttachedCommunication";
import { EditMode, HistoryTab, PatientTab } from "@/Common/Models/Patient/PatientEnums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientHistoryHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalPatientOperations.History.ChangeHistoryTab, this.changeHistoryTab);

        this.RegisterOperation(LocalPatientOperations.History.TaskRedirectFromEncounterOrLabs, this.changeToHistoryTaskTab);
        this.RegisterOperation(LocalPatientOperations.History.MessageRedirectFromEncounter, this.changeToHistoryMessageTab);
        this.RegisterOperation(LocalPatientOperations.History.RecallRedirectFromEncounter, this.changeToHistoryRecallTab);
        this.RegisterOperation(LocalPatientOperations.History.AttachedCommunicationsClose, this.closeAttachedCommunication);
    }

    private changeHistoryTab(request: LocalEvent, store: PatientStore): void {
        var value = request.Get<number>("value");
        var activePatientUI = store.PatientUIModels[request.PatientId];
        activePatientUI = activePatientUI.set("PatientHistoryActiveTab", value);
        activePatientUI = activePatientUI.set("PatientHistoryEditMode", EditMode.View);
        store.PatientUIModels[request.PatientId] = activePatientUI;
    }

    private changeToHistoryTaskTab(request: LocalEvent, store: PatientStore): void {
        this.updateModelsForTabChange(HistoryTab.Task, request.PatientId, store);

        let attachedCommunications = request.Get<AttachedCommunication[]>("attachedCommunications");
        let isFromDocument = request.Get<boolean>("isFromDocument");
        let isFromLab = request.Get<boolean>("isFromLab");

        store.ActionsHistory.loadSingleTask(
            attachedCommunications
                .sortByPropertyDesc(a => a.CreatedDate)
                .firstOrDefault()
                .IndividualMessageId
        );

        if (isFromDocument)
            documentsStore.DocumentsModel = documentsStore.DocumentsModel.set("AttachedCommunicationsPopupOpen", false);
        if (isFromLab)
            labsStore.LabModel = labsStore.LabModel.set("AttachedCommunicationsPopupOpen", false);
    }

    private changeToHistoryMessageTab(request: LocalEvent, store: PatientStore): void {
        this.updateModelsForTabChange(HistoryTab.Message, request.PatientId, store);

        let attachedCommunications = request.Get<AttachedCommunication[]>("attachedCommunications");

        store.ActionsHistory.loadSingleMessage(
            attachedCommunications
                .sortByPropertyDesc(a => a.CreatedDate)
                .firstOrDefault()
                .IndividualMessageId
        );
    }

    private changeToHistoryRecallTab(request: LocalEvent, store: PatientStore): void {
        this.updateModelsForTabChange(HistoryTab.Recall, request.PatientId, store);

        let attachedCommunications = request.Get<AttachedCommunication[]>("attachedCommunications");
        store.ActionsHistory.loadSingleRecall(
            attachedCommunications
                .sortByPropertyDesc(a => a.CreatedDate)
                .firstOrDefault()
                .RecallId
        );
    }

    private closeAttachedCommunication(request: LocalEvent, store: PatientStore): void {
        this.hideAttachedCommunicationsPopup(request.PatientId, store);
        store.EmitChangeToListeners();
    }

    private updateModelsForTabChange(tab: HistoryTab, patientId: string, store: PatientStore): void {
        let uiModel = store.PatientUIModels[patientId];
        uiModel = uiModel
            .set("ActiveVerticalTab", PatientTab.History)
            .set("PatientHistoryActiveTab", tab);
        store.PatientUIModels[patientId] = uiModel;

        this.hideAttachedCommunicationsPopup(patientId, store);
    }

    private hideAttachedCommunicationsPopup(patientId: string, store: PatientStore): void {
        if (documentsStore.DocumentsModel.get("AttachedCommunicationsPopupOpen")) {
            documentsStore.DocumentsModel = documentsStore.DocumentsModel.set("AttachedCommunicationsPopupOpen", false);
            documentsStore.EmitChangeToListeners();
        }

        if (labsStore.LabModel.get("AttachedCommunicationsPopupOpen")) {
            labsStore.LabModel = labsStore.LabModel.set("AttachedCommunicationsPopupOpen", false);
            labsStore.EmitChangeToListeners();
        }

        let medicalNoteModel = store.PatientMedicalNoteModels[patientId];
        if (medicalNoteModel && medicalNoteModel.get("AttachedCommunicationsPopupOpen")) {
            medicalNoteModel = medicalNoteModel.set("AttachedCommunicationsPopupOpen", false);
            store.PatientMedicalNoteModels[patientId] = medicalNoteModel;
        }
    }
}

export { PatientHistoryHandler };
